import { createStore } from "vuex";

import {HTTP} from "../modules/http-common"

//const plugin = createWebSocketPlugin(socket)

export default createStore({
    state: {
        user: {
            id:0,
            phone:'',
        },
        menuCount:{
            order:0,
            basket:0,
        },
        socketMessages:[],
    },
    getters: {
        getUser: (state) => state.user,
        getOrderCount: (state) => state.menuCount.order,
        getBasketCount: (state) => state.menuCount.basket,
        onSocketMessage: (state) => state.menuCount.basket,
    },
    actions: {
        async fetchStart({ commit }, params) {
            return new Promise((resolve, reject) => {
                HTTP.get(
                    "/page/start"
                ).then(function (json) {
                    if (json.data.user) {
                        commit("SET_INFO", json.data)
                        resolve();
                    } else {
                        reject();
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    reject();
                });
            });
        },
        async logout({ commit }, params) {
            return new Promise((resolve, reject) => {
                HTTP.get(
                    "/auth/logout"
                ).then(function (json) {
                    commit("SET_INFO", {
                        user:{
                            id:0,
                            phone:'',
                        },
                        menuCount:{
                            order:0,
                            basket:0,
                        },
                    })
                    resolve();
                })
                .catch(function (error) {
                    console.log(error);
                    reject();
                });
            });
        },
        onSocket({ commit }, message) {
            commit("SET_SOCKET_MESSAGE", message)
        }
    },
    mutations: {
        SET_INFO(state, data) {
            HTTP.defaults.headers.common['X-CSRF-TOKEN'] = data.csrf;
            state.user = data.user;
            state.menuCount = data.menu_count;
        },
        SET_SOCKET_MESSAGE(state, data) {
            if(false){
                state.socketMessages.push(data);
            }else{
                document.dispatchEvent(
                    new CustomEvent("onSocketMessage", {
                        detail: data
                    })
                );
            }
        }
    },
    //plugins: [plugin]
});